import Vue from 'vue'
import http from '@/services/http.service'

// 各コンポーネントからアクセスするときの名前登録（テンプレ）
Vue.mixin({
  beforeCreate() {
    const options = this.$options
    if (options.dialog) this.$site = options.site
    else if (options.parent && options.parent.$site)
      this.$site = options.parent.$site
  },
})

export default {
  getSite() {
    return http.get('/sites').then(r => r.data)
  },
}
